import React, { useState, useEffect } from 'react';
import {
    Box, Button, Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Table, TableBody, TableCell, TableHead, TableRow,
    Typography, Paper, Stack, Grid, MenuItem, Avatar, CircularProgress,
    IconButton, Card, Tooltip
} from '@mui/material';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';
import { updateDoc, doc, getDoc } from 'firebase/firestore';
import { auth, db, storage } from '../../../firebase';
import { toast } from 'react-toastify';

const Property = () => {
    const [formData, setFormData] = useState({
        name: '', email: '', mobile: '', address: '',
        city: '', state: '', country: '', pincode: '',
        status: '', logo: ''
    });
    const [preview, setPreview] = useState('');
    const [logoFile, setLogoFile] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        const user = auth.currentUser;
        if (!user) return console.error("No authenticated user found.");

        try {
            const docRef = doc(db, "institutes", user.uid);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                const data = docSnap.data();
                setFormData({
                    name: data.name || '',
                    email: data.email || '',
                    mobile: data.mobile || '',
                    address: data.address || '',
                    city: data.city || '',
                    state: data.state || '',
                    country: data.country || '',
                    pincode: data.pincode || '',
                    logo: data.logo || ''
                });
                setPreview(data.logo || '');
            }
        } catch (error) {
            console.error("Error fetching institute data:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogoFile(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const user = auth.currentUser;
            let logoURL = formData.logo;

            if (logoFile) {
                const logoRef = ref(storage, `logos/${uuidv4()}`);
                await uploadBytes(logoRef, logoFile);
                logoURL = await getDownloadURL(logoRef);
            }

            await updateDoc(doc(db, 'institutes', user.uid), {
                ...formData,
                logo: logoURL,
                updatedAt: new Date(),
            });

            toast.success('Property details updated successfully!');
            fetchData();
        } catch (err) {
            console.error(err);
            toast.error('Error: ' + err.message);
        }
        setLoading(false);
    };

    return (
        <Box>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h5" fontWeight="bold">
                    Property Details
                </Typography>

            </Stack>
            <Card sx={{ p: 5 }}>
                <div className='row'>
                    <Grid className="col-sm-4 mb-4">
                        <TextField label="Institute Name" name="name" fullWidth size="small" value={formData.name} onChange={handleChange} required />
                    </Grid>
                    <Grid className="col-sm-4 mb-4">
                        <TextField label="Email" name="email" type="email" fullWidth size="small" value={formData.email} onChange={handleChange} required />
                    </Grid>
                    <Grid className="col-sm-4 mb-4">
                        <TextField label="Mobile" name="mobile" fullWidth size="small" value={formData.mobile} onChange={handleChange} required />
                    </Grid>
                    <Grid className="col-sm-4 mb-4">
                        <TextField label="Address" name="address" fullWidth size="small" multiline rows={2} value={formData.address} onChange={handleChange} required />
                    </Grid>
                    <Grid className="col-sm-4 mb-4">
                        <TextField label="City" name="city" fullWidth size="small" value={formData.city} onChange={handleChange} required />
                    </Grid>
                    <Grid className="col-sm-4 mb-4">
                        <TextField label="State" name="state" fullWidth size="small" value={formData.state} onChange={handleChange} required />
                    </Grid>
                    <Grid className="col-sm-4 mb-4">
                        <TextField label="Country" name="country" fullWidth size="small" value={formData.country} onChange={handleChange} required />
                    </Grid>
                    <Grid className="col-sm-4 mb-4">
                        <TextField label="Pincode" name="pincode" fullWidth size="small" value={formData.pincode} onChange={handleChange} required />
                    </Grid>
                    <Grid className="col-sm-4 mb-4">
                        <Button variant="outlined" component="label" fullWidth>
                            Upload Logo
                            <input hidden type="file" accept="image/*" onChange={handleLogoChange} />
                        </Button>
                        {preview && <Avatar src={preview} sx={{ width: 56, height: 56, mt: 1 }} />}
                    </Grid>
                </div>
                <Button variant="contained" onClick={handleSubmit} disabled={loading}>
                    {loading ? <CircularProgress size={24} /> : 'Update'}
                </Button>
            </Card>
        </Box>
    );
};

export default Property;
